import React from 'react';
import PropTypes from 'prop-types';
import { X } from 'lucide-react';
import './DeleteConfirmation.css';

const DeleteConfirmation = ({ message, onCancel, onConfirm }) => {
  return (
    <div className="delete-confirmation-modal">
      <div className="delete-confirmation-content">
        <div className="delete-confirmation-header">
          <h2>Confirm Deletion</h2>
          <button onClick={onCancel} className="close-btn">
            <X size={18} />
          </button>
        </div>
        
        <div className="delete-confirmation-body">
          <p className="delete-message">{message}</p>
          <div className="warning-icon">⚠️</div>
          <p className="delete-warning">This action will be deleted permanently.</p>
        </div>
        
        <div className="delete-confirmation-actions">
          <button 
            className="cancel-button"
            onClick={onCancel}
          >
            Cancel
          </button>
          
          <button 
            className="delete-button"
            onClick={onConfirm}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

DeleteConfirmation.propTypes = {
  message: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};

export default DeleteConfirmation;